import api from '../../../../api.js';
import {handleResponseErrors} from '../../../services/processServerErrors.js';

export async function upload(values, fetchConf) {
  return api.freelances.skillsFile.upload(values, fetchConf).catch(handleResponseErrors);
}

export async function deleteSkillsFile(values) {
  return api.freelances.skillsFile.delete(values).catch(handleResponseErrors);
}